import { render, staticRenderFns } from "./noSummary.vue?vue&type=template&id=36d1ffa8&scoped=true&"
import script from "./noSummary.vue?vue&type=script&lang=js&"
export * from "./noSummary.vue?vue&type=script&lang=js&"
import style0 from "./noSummary.vue?vue&type=style&index=0&id=36d1ffa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d1ffa8",
  null
  
)

export default component.exports